<template>
  <div>
    <top class="module_top" :show="false" ></top>
    <div class="module">
      <el-col class="naving" :span="4">
        <el-menu
          @select="handSelect"
          :default-active="navIndex"
          class="el-menu-vertical-demo"
          style="min-height: 80vh">
          <template v-for="(item, index) in navData">
            <el-menu-item :index="item.id.toString()" :key="index" v-if="item.next.length === 0">
              <i :class="item.iconUrl"></i>
              <span slot="title">{{ item.kindName }}</span>
            </el-menu-item>
            <el-submenu :index="item.id.toString()" :key="index" v-else>
              <template slot="title">
                <i :class="item.iconUrl"></i>
                <span slot="title">{{ item.kindName }}</span>
              </template>
              <div class="insert">
                <el-menu-item  v-for="(itemInfo, index) in item.next" :key="index" :index="itemInfo.id.toString()">
                  <span style="padding-left: 20px">{{ itemInfo.kindName }}</span>
                </el-menu-item>
              </div>
              
            </el-submenu>
          </template>
          <el-menu-item index="10000">
            <i class="el-icon-monitor"></i>
            <span>亚马逊FBA利润计算视频</span>
          </el-menu-item>
          <div style="display: flex;">
            <span class="menu_button" @click="
            navIndex = '24097';
            $router.push({
            path: 'operation',
              query:{
                newsType: '24097'
              }})" v-if="userType === 'ROLE_ADMIN' || userType === 'ROLE_NEWS_ADMIN'">
              文章任务发布
            </span>
            <span class="menu_button"
                  style="margin-left: 0"
                  @click="showVideoDialog = true"
                  v-if="userType === 'ROLE_ADMIN' || userType === 'ROLE_NEWS_ADMIN'">视频任务发布</span>
          </div>
        </el-menu>
      </el-col>
      <el-col :span="20" v-if="navIndex !== '24097' && !$route.query.newsId && navIndex !== '10000'">
        <div class="first_title">{{ navName[navIndex] }}</div>
        <div class="news_content">
          <div class="news" v-for="(item, index) in newList" :key="index" @click="newsDetail(item.id)">
            <div class="top">
              <div>{{ item.title }}</div>
              <div>{{ new Date(item.publishTime).Format('yyyy-MM-dd') }}</div>
            </div>
            <div class="bottom">{{ item.description }}</div>
            <div v-if="userType === 'ROLE_ADMIN' || userType === 'ROLE_NEWS_ADMIN'" class="textarea_button" @click.stop>
              <div><button @click="deleteDialog = true;deleteIndex = item.id">删除</button></div>
              <div><button @click="changeContext(item.id)">修改</button></div>
            </div>
          </div>
        </div>
        <div style="text-align: center" v-show="newPages">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="newPages">
          </el-pagination>
        </div>
      </el-col>
      <el-col :span="20" v-else-if="navIndex !== '24097' && $route.query.newsId && navIndex !== '10000'">
        <div class="textarea_content">
          <div class="title">{{ newsTitle }}</div>
          <div v-html="newsContent"></div>
        </div>
      </el-col>
      <el-col :span="20" v-else-if="navIndex === '10000'">
        <div class="video_module">
          <div class="video_info">
            <div class="video_item" v-for="(item, index) in videoList" :key="index" @click="clickVideo(item.videoUrl)">
              <div style="height: 80%;display: flex">
                <img :src="item.coverPic" alt="">
              </div>
              <div class="name">{{ item.title }}</div>
              <div style="display: flex;justify-content: space-between;padding: 0 10px;margin: 10px 0;color: #b1b1b1">
                <div>{{ item.publisherName}}</div>
                <div>{{ item.publishTime}}</div>
              </div>
                <button @click.stop @click="change(item.id, index)" v-if="userType === 'ROLE_ADMIN' || userType === 'ROLE_NEWS_ADMIN'">修改</button>
                <button @click.stop @click="deleteVideo(item.id,index)" style="left: 0" v-if="userType === 'ROLE_ADMIN' || userType === 'ROLE_NEWS_ADMIN'">删除</button>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="20" v-else-if="navIndex === '24097'">
        <div class="first_title" style="display: flex;justify-content: space-between">
          <div>任务发布</div>
          <div>请前往该<el-link type="primary" @click="openOtherWeb('https://www.135editor.com')">网页</el-link>，将需要上传的文章转成H5的形式</div>
        </div>
        <div class="text_content">
          <el-input
            placeholder="请输入文章标题"
            v-model="textTitle"
            style="margin: 10px 0"
            clearable>
          </el-input>
          <el-input
            type="textarea"
            :autosize="{minRows: 10, maxRows: 25}"
            placeholder="请输入对应的文章代码"
            v-model="textContent">
          </el-input>
          <div class="bottom">
            <div>
              <el-input
                placeholder="添加的分类(有需要再填写)"
                v-model="addKindName"
                style="width: 210px;margin: auto 10px auto 0"
                clearable>
              </el-input>
              <el-select v-model="selectValue" placeholder="请选择文章类别">
                <el-option
                  v-for="item in newType"
                  :key="item.id"
                  :label="item.kindName"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div>
              <button @click="addKind" style="margin: auto 10px auto 0">添加</button>
              <button @click="upload">上传</button>
            </div>
          </div>
        </div>
      </el-col>
    </div>
    <dialog-tip :show="deleteDialog" title="温馨提示" @cancel="cancelDeleteDialog">
      <div class="tip_main">该删除操作不可逆，是否删除</div>
      <div class="tip_btn">
        <button @click="deleteData">删除</button>
        <button @click="cancelDeleteDialog">取消</button>
      </div>
    </dialog-tip>
    <dialog-tip :show="deleteDialog1" title="温馨提示" @cancel="cancelDeleteDialog1">
      <div class="tip_main">该删除操作不可逆，是否删除</div>
      <div class="tip_btn">
        <button @click="ensureDeleteVideo">删除</button>
        <button @click="cancelDeleteDialog1">取消</button>
      </div>
    </dialog-tip>
    <el-dialog title="视频上传" :visible.sync="showVideoDialog" width="500px">
      <div class="dialog_input">
        <div>
          请输入视频标题：
          <el-input
            placeholder="请输入视频标题"
            v-model="videoTitle"
            clearable
            class="el_input">
          </el-input>
        </div>
        <div>
          请输入视频链接：
          <el-input
            placeholder="请输入视频链接"
            v-model="videoLink"
            clearable
            class="el_input">
          </el-input>
        </div>
        <div>
          请输入视频作者名称：
          <el-input
            placeholder="请输入作者名称"
            v-model="videoAuthor"
            clearable
            class="el_input">
          </el-input>
        </div>
      </div>
      <div style="display: flex;">
        <div style="margin: auto 5px auto 0">请选择视频封面：</div>
        <div v-show="!imgUpload" class="upload_block">
          <div class="upload_text">
            <img src="../../assets/img/add.png" alt="" style="width: 40px;height: 40px;margin:auto;">
            <div style="text-align: center;margin: 5px 0">添加图片</div>
          </div>
          <input id="img" type="file" class="inputPic" multiple @change="uploadFile">
        </div>
        <div v-if="imgUpload" class="upload_block">
          <img src="../../assets/img/close.png" alt="" class="img_close" @click="changeImg">
          <img :src="imgShow" alt="" class="img_show">
        </div>
      </div>
      <div class="dialog_bottom">
        <button @click="uploadVideo">上传</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import top from "@/components/content/top";
import {request} from "@/network/request";
import 'common/Format'
import Dialog_tip from "@/components/common/Dialog_tip";
import {getBase64Image} from "@/common/getBase64Image";

export default {
  name: "operation",
  components:{
    'top': top,
    'dialog-tip': Dialog_tip
  },
  data(){
    return{
      // 删除对话框
      deleteDialog: false,
      deleteDialog1: false,
      // 删除视频的id和index
      videoDeleteId:'',
      videoDeleteIndex:'',
      deleteIndex: '',
      // 用户类型
      userType: '',
      // 添加分类
      addKindName: '',
      // 导航栏
      navData:[],
      navIndex: 1,
      // 导航栏名称
      navName:[],
      // 文章类别
      newType:[],
      // 所选类别
      selectValue: '',
      // 资讯列表
      newList: [],
      // 资讯总页码数
      newPages: 0,
      // 文章标题
      textTitle: '',
      // 文本框内容
      textContent: '',
      // 资讯内容
      newsContent: '',
      newsTitle: '',
      // 是否是修改文章
      isChange: false,
      changeId: '',
      // 视频列表
      videoList: [
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
        {
          title: '测试数据',
          coverPic: '',
          videoUrl: ''
        },
      ],
      // 视频上传弹窗
      showVideoDialog: false,
      // 视频标题
      videoTitle: '',
      // 视频链接
      videoLink: '',
      // 视频作者
      videoAuthor:'',
      // 上传图片
      imgUpload: false,
      // 图片地址
      imgShow: '',
      // 上传类型
      uploadType: 'upload',
      // 修改索引
      videoChangeId: '',
    }
  },
  methods:{
    // 更改资讯类别
    handSelect(key){
      this.newList = []
      if(this.$route.query.newsType !== key){
        this.$router.push({
          path: 'operation',
          query:{
            newsType: key
          }
        })
        this.navIndex = key
      }else if(this.$route.query.newsId || this.$route.query.newsId === '0'){
        this.$router.push({
          path: 'operation',
          query:{
            newsType: key
          }
        })
        this.navIndex = key
      }
      if(this.navIndex !== '10000' && this.navIndex !== '24097'){
        request({
          url:'/news/newsList',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data:{
            "page": 1,
            "row": 9,
            "kind": parseInt(this.navIndex),
          }
        }).then(res =>{
          if(res.data.code === 1){
            this.newList = res.data.info.list
            this.newPages = res.data.info.pages
          }else {
            this.$message.error(res.data.info)
          }
        })
      }else if(this.navIndex === '10000'){
        request({
          url:'/video/list',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        }).then(res =>{
          if(res.data.code === 1){
            this.videoList = res.data.info
            for (let i = 0; i < res.data.info.length; i ++){
              this.videoList[i].coverPic = '/api/video/coverPic/' + this.videoList[i].coverPic
            }
          }
        })
      }
    },
    // 打开外部网页
    openOtherWeb(url){
      window.open(url)
    },
    // 添加分类
    addKind(){
      request({
        url:'/news/admin/addKind',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data:{
          "kindName": this.addKindName,
          "parentId": 1
        }
      }).then(res =>{
        if(res.data.code === 1){
          this.$message.success(res.data.info)
          request({
            url:'/news/secondKind',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
          }).then(res =>{
            if(res.data.code === 1){
              this.newType = res.data.info
            }
          })
          request({
            url:'/news/kind',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
          }).then(res =>{
            if(res.data.code === 1){
              this.navData = res.data.info.kinds
              this.navName = res.data.info.names
            }
          })
        }else{
          this.$message.error(res.data.info)
        }
      })
    },
    // 上传文章
    upload(){
      if(!this.selectValue){
        this.$message.error('请选择文章类别')
      }else{
        if(this.isChange){
          request({
            url:'/news/admin/update',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data:{
              "id": this.changeId,
              "title": this.textTitle,
              "article": this.textContent,
              "kindId": parseInt(this.selectValue),
            }
          }).then(res =>{
            if(res.data.code === 1){
              this.textTitle = ''
              this.textContent = ''
              this.changeId = ''
              this.isChange = false
              this.$message.success(res.data.info)
              this.$router.push({
                path: '/operation',
                query:{
                  newsType: '2'
                }
              })
              this.navIndex = '2'
              request({
                url:'/news/newsList',
                method: 'post',
                header: {
                  'Content-Type': 'application/json'
                },
                data:{
                  "page": 1,
                  "row": 9,
                  "kind": this.$route.query.newsType,
                }
              }).then(res =>{
                if(res.data.code === 1){
                  this.newList = res.data.info.list
                  this.newPages = res.data.info.pages
                }else {
                  this.$message.error(res.data.info)
                }
              })
            }else {
              this.$message.error(res.data.info)
            }
          })
        }else {
          request({
            url:'/news/admin/publish',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data:{
              "title": this.textTitle,
              "article": this.textContent,
              "kindId": parseInt(this.selectValue),
            }
          }).then(res =>{
            if(res.data.code === 1){
              this.textTitle = ''
              this.textContent = ''
              this.$router.push({
                path: '/operation',
                query:{
                  newsType: '2'
                }
              })
              this.navIndex = '2'
              this.$message.success(res.data.info)
            }else {
              this.$message.error(res.data.info)
            }
          })
        }
      }
    },
    // 打开文章详细信息
    newsDetail(id){
      this.newsTitle = this.newsContent = ''
      this.$router.push({
        path: 'operation',
        query:{
          newsType: this.navIndex,
          newsId: id
        }
      })
      request({
        url:'/news/detail',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data:{
          "id": id
        }
      }).then(res =>{
        if(res.data.code === 1){
          this.newsContent = res.data.info.article
          this.newsTitle = res.data.info.title
        }
      })
    },
    // 删除数据
    deleteData(){
      request({
        url: '/news/admin/remove',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data: {
          "id": this.deleteIndex
        }
      }).then(res => {
        if(res.data.code === 1){
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.$router.replace({
            path: 'operation',
            query:{
              newsType: this.navIndex
            }
          })
          this.deleteDialog = false
          request({
            url:'/news/newsList',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data:{
              "page": 1,
              "row": 9,
              "kind": parseInt(this.navIndex) === 1? null:parseInt(this.navIndex),
            }
          }).then(res =>{
            if(res.data.code === 1){
              this.newList = res.data.info.list
              this.newPages = res.data.info.pages
            }else {
              this.$message.error(res.data.info)
            }
          })
        }else if(res.data.code === 1020 || res.data.code === 1000){
          this.$message.error(res.data.info)
          this.$router.replace('/login')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    cancelDeleteDialog(){
      this.deleteDialog = false
    },
    cancelDeleteDialog1(){
      this.deleteDialog1 = false
    },
    // 修改文章
    changeContext(id){
      this.newsTitle = this.newsContent = ''
      this.changeId = id
      this.isChange = true
      this.navIndex = '24097'
      this.$router.push({
        path: 'operation',
        query:{
          newsType: "24097",
        }
      })
      request({
        url:'/news/detail',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data:{
          "id": id
        }
      }).then(res =>{
        if(res.data.code === 1){
          this.textContent = res.data.info.article
          this.textTitle = res.data.info.title
          this.selectValue = res.data.info.newsKind
        }
      })
    },
    // 上传视频
    uploadVideo(){
      if(this.uploadType === 'upload'){
        request({
          url: '/video/admin/addVideo',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "title": this.videoTitle,
            "videoUrl": this.videoLink,
            "coverPic": this.imgShow,
            "publisherName": this.videoAuthor
          },
        }).then(res =>{
          if(res.data.code === 1){
            this.$message.success(res.data.info)
            this.videoTitle = ''
            this.videoLink = ''
            this.imgShow = ''
            this.videoAuthor = ''
            this.imgUpload = false
            this.showVideoDialog = false
          }else {
            this.$message.error(res.data.info)
          }
        })
      }else if(this.uploadType === 'change'){
        request({
          url: '/video/admin/updateVideo',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "id": this.videoChangeId,
            "title": this.videoTitle,
            "videoUrl": this.videoLink,
            "coverPic": this.imgShow,
            "publisherName": this.videoAuthor
          },
        }).then(res =>{
          if(res.data.code === 1){
            this.$message.success(res.data.info)
            this.$router.go(0)
          }else {
            this.$message.error(res.data.info)
          }
        })
      }
    },
    // 上传图片
    uploadFile(){
      let file = document.getElementById('img').files[0]
      if(!/image\/\w+/.test(file.type)){
        this.$message.error('文件必须为图片！')
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) =>{
        this.imgShow = e.target.result
      }
      if(!file){
        return
      }else {
        this.imgUpload = true
      }
    },
    // 重新选择图片
    changeImg(){
      this.imgUpload = false
      this.imgShow = ''
    },
    clickVideo(url){
      window.open(url)
    },
    // 修改视频数据
    change(id, index){
      request({
        url: '/video/id',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data: {
          "id": id
        },
      }).then(res =>{
        if(res.data.code === 1){
          this.uploadType = 'change'
          this.videoChangeId = id
          this.videoTitle = this.videoList[index].title
          this.videoLink = this.videoList[index].videoUrl
          this.videoAuthor = this.videoList[index].publisherName
          getBase64Image(this.videoList[index].coverPic).then((res) => {
            this.imgShow = res
            this.imgUpload = true
          })
          this.showVideoDialog = true
        }
      })
    },

    // 删除视频数据
    deleteVideo(id,index){
      this.videoDeleteId = id
      this.videoDeleteIndex = index
      this.deleteDialog1 = true
    },
    // 确定删除
    ensureDeleteVideo(){
      request({
        url:'/video/admin/deleteVideo',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data: {
          "id": this.videoDeleteId
        },
      }).then( res => {
        if(res.data.code === 1){
          this.videoList.splice(this.videoDeleteIndex,1)
          this.$message.success(res.data.info)
          this.deleteDialog1 = false
        }else if(res.data.code === 10001){
          this.$message.error(res.data.info)
        }else{
          this.$message.error(res.data.info)
        }
      })
    }
  },
  created() {
    if(this.$route.query.newsType){
      this.navIndex = this.$route.query.newsType
    }else{
      this.navIndex = '2'
    }
    request({
      url:'/user/userInfo',
      method: 'post',
      header: {
        'Content-Type': 'application/json'
      },
    }).then(res =>{
      if(res.data.code === 1){
        this.userType = res.data.info.authorities[0].authority
        if(this.userType === 'ROLE_ADMIN' || this.userType === 'ROLE_NEWS_ADMIN'){
          request({
            url:'/news/secondKind',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
          }).then(res =>{
            if(res.data.code === 1){
              this.newType = res.data.info
            }
          })
        }
      }
    })
    if(this.$route.query.newsId){
      request({
        url:'/news/detail',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data:{
          "id": this.$route.query.newsId
        }
      }).then(res =>{
        if(res.data.code === 1){
          this.newsContent = res.data.info.article
          this.newsTitle = res.data.info.title
        }
      })
    } else if(this.navIndex !== '24097' && this.navIndex !== '10000'){
      request({
        url:'/news/newsList',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        data:{
          "page": 1,
          "row": 9,
          "kind": this.navIndex,
        }
      }).then(res =>{
        if(res.data.code === 1){
          this.newList = res.data.info.list
          this.newPages = res.data.info.pages
        }else {
          this.$message.error(res.data.info)
        }
      })
    }else if(this.navIndex === '10000'){
      request({
        url:'/video/list',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
      }).then(res =>{
        if(res.data.code === 1){
          this.videoList = res.data.info
          for (let i = 0; i < res.data.info.length; i ++){
            this.videoList[i].coverPic = '/api/video/coverPic/' + this.videoList[i].coverPic
          }
        }
      })
    }
    request({
      url:'/news/kind',
      method: 'post',
      header: {
        'Content-Type': 'application/json'
      },
    }).then(res =>{
      if(res.data.code === 1){
        this.navData = res.data.info.kinds
        this.navName = res.data.info.names
      }
    })
  }
}
</script>

<style scoped>
.module_top{
  background-color: #022028;
  padding: 0 200px;
}

.module{
  margin: 20px 5%;
  min-height: 80vh;
  background-color: #fff;
}

.first_title{
  color: black;
  font-size: 16px;
  margin: 20px 50px;
}

.news_content{
  max-height: 640px;
}

.news{
  margin: 0 40px;
  font-size: 14px;
  padding: 10px;
  border-bottom: 1px dashed #e6e6e6;
  cursor: pointer;
  position: relative;
}

.news:hover{
  opacity: .8;
  background-color: #fafafa;
}

.news .top{
  display: flex;
  justify-content: space-between;
  color: black;
  margin: 5px 50px 15px 0;
}

.news .bottom{
  color: #9c9c9c;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text_content{
  margin: 10px 50px;
}

.text_content .bottom{
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}

.text_content .bottom button{
  padding: 10px 30px ;
  outline: none;
  border: none;
  border-radius: 5px;
  background-color: #19ACFD;
  color: white;
  cursor: pointer;
}

.text_content .bottom button:hover{
  opacity: .8;
}

.textarea_content{
  padding: 10px;
  background-color: #fff;
  user-select: text;
}

.textarea_content .title{
  font-size: 25px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin: 10px;
}

.textarea_button{
  position: absolute;
  right: 10px;
  top: 10px;
}

.textarea_button button{
  background-color: #19ACFD;
  border: none;
  outline: none;
  border-radius: 5px;
  color: white;
  padding: 5px 10px;
  margin: 2px 0;
  font-size: 12px;
  cursor: pointer;
}

.textarea_button button:hover{
  opacity: .8;
}

.tip_main{
  font-size: 15px;
  font-weight: bold;
  width: 500px;
  padding: 20px;
  color: black;
}

.tip_btn{
  display: flex;
  justify-content: space-between;
}

.tip_btn button{
  background-color: #19ACFD;
  color: white;
  padding: 10px 15px;
  border: none;
  outline: none;
  border-radius: 10px;
  margin: 10px 20px;
}

.tip_btn button:hover{
  cursor: pointer;
  opacity: .8;
}

.menu_button{
  display: block;
  padding: 10px 0;
  text-align: center;
  background-color: #19ACFD;
  color: white;
  border-radius: 5px;
  margin: 10px 20px;
  width: 80px;
  cursor: pointer;
}

.menu_button:hover{
  opacity: .8;
}

.dialog_input .el_input{
  width: 300px;
  margin: 0 20px 10px 0;
}

.upload_block{
  width: 120px;
  height: 120px;
  border: 1px solid #dcdfe6;
  font-size: 12px;
  border-radius: 5px;
  margin: 2px 0;
  position: relative;
}

.img_close{
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  z-index: 30;
}

.img_close:hover{
  cursor: pointer;
  opacity: .8;
}

.upload_text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -40%);
  z-index: 10;
}

.inputPic{
  position: relative;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
  z-index: 100;
  width: 100%;
  height: 100%;
}

.inputPic:hover{
  cursor: pointer;
}

.img_show{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  max-height: 100px;
}

.dialog_bottom{
  text-align: end;
}

.dialog_bottom button{
  background-color: #19ACFD;
  border-radius: 5px;
  border: none;
  outline: none;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
}

.dialog_bottom button:hover{
  opacity: .8;
}

.video_info{
  display: flex;
  flex-wrap: wrap;
  /*justify-content: center;*/
}

/*.video_item{*/
/*  width: 20%;*/
/*  margin: 20px 2.5%;*/
/*  background-color: #fff;*/
/*  border-radius: 10px;*/
/*  cursor: pointer;*/
/*  box-shadow: 5px 10px 15px 2px #e6e6e6;*/
/*  height: 250px;*/
/*  position: relative;*/
/*}*/
.video_item{
  width: 23%;
  margin: 20px 1%;
  background-color: #fff;
  cursor: pointer;
  height: 250px;
  position: relative;
  border: 1px solid #e8e8e8;
}

.video_item:hover{
  opacity: .8;
}

/*.video_item img{*/
/*  width: 80%;*/
/*  max-height: 75%;*/
/*  margin: 10px 10%;*/
/*  display: block;*/
/*}*/
.video_item img{
  width: 100%;
  max-height: 95%;
  display: block;
}

/*.video_item .name{*/
/*  text-align: center;*/
/*  !*color: black;*!*/
/*  color: #c7b7b7;*/
/*  font-size: 14px;*/
/*  padding: 0 10px;*/
/*  font-weight: bold;*/
/*  overflow: hidden;*/
/*  -webkit-line-clamp: 2;*/
/*  line-clamp: 2;*/
/*  -webkit-box-orient: vertical;*/
/*  box-orient: vertical;*/
/*  display: -webkit-box;*/
/*}*/
.video_item .name{
  /*text-align: center;*/
  /*color: black;*/
  /*color: #c7b7b7;*/
  font-size: 12px;
  padding: 0 10px;
  /*font-weight: bold;*/
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  display: -webkit-box;
}

.video_item button{
  position: absolute;
  bottom: -10px;
  right: 0px;
  background-color: #19ACFD;
  outline: none;
  border: none;
  border-radius: 5px;
  color: white;
  padding: 5px 10px;
  cursor: pointer;
}

.video_module{
  background-color: #fff;
}

.video_module button:hover{
  opacity: .6;
}

</style>
<style lang="scss">
  @media screen and (max-width: 1600px){
    .module .el-menu{
      min-width: 20rem;
      font-size: 1rem;
    }
  }
  @media screen and (min-width: 1600px){
    .module .el-menu{
      min-width: 17rem;
      font-size: 1rem;
    }
  }
  .naving{
    .el-menu-item, .el-submenu__title{
      line-height: 37px !important;
      height: 37px !important;
      // font-size: 12px !important;
    }
    .el-menu-item .el-submenu{
        line-height: 40px !important;
        height: 40px !important;
    }
  }
  .insert{
    .el-menu-item{
      font-size: 12px;
    }
    .el-menu-item, .el-submenu__title{
      line-height: 25px !important;
      height: 25px !important;
    }
  }
</style>
